import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaBook, FaPlus, FaUser, FaCompass, FaBell, FaSearch } from 'react-icons/fa';

function MobileHeader({ userId, categories, navigate }) {
  const [showMobileAddDropdown, setShowMobileAddDropdown] = useState(false);
  const mobileAddDropdownRef = useRef(null);

  const closeAllDropdowns = () => {
    setShowMobileAddDropdown(false);
  };

  const toggleMobileAddDropdown = () => {
    setShowMobileAddDropdown(!showMobileAddDropdown);
  };

  const handleMobileCategoryClick = (categoryId, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    closeAllDropdowns();
    navigate(`/category/${categoryId}`);
  };

  const navigateAndCloseDropdowns = (path) => {
    navigate(path);
    closeAllDropdowns();
  };

  const handleClickOutside = (event) => {
    if (
      mobileAddDropdownRef.current &&
      !mobileAddDropdownRef.current.contains(event.target) &&
      !event.target.closest('.mobile-footer .footer-button[data-action="add"]')
    ) {
      closeAllDropdowns();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <header className="header">
        <div className="header-left">
          <div className="logo">
            <Link to="/dashboard">
              <img src="/LİBROZİ BOŞ MOR.png" alt="KitapOku Logo" className="logo-image" />
            </Link>
          </div>
        </div>

        <div className="header-spacer"></div>

        <div className="mobile-actions">
          <Link to="/discover" className="mobile-discover">
            <FaCompass />
          </Link>
          <Link to="/notifications" className="mobile-notification">
            <FaBell />
          </Link>
        </div>
      </header>

      {showMobileAddDropdown && (
        <div className="mobile-add-dropdown" ref={mobileAddDropdownRef}>
          <button onClick={() => navigateAndCloseDropdowns('/new-story')}>
            Yeni bir hikaye oluştur
          </button>
          <button onClick={() => navigateAndCloseDropdowns('/my-stories')}>
            Hikayelerim
          </button>
        </div>
      )}

      <div className="mobile-footer">
        <button onClick={() => navigateAndCloseDropdowns('/dashboard')} className="footer-button">
          <FaHome />
          <span>Home</span>
        </button>
        <button onClick={() => navigateAndCloseDropdowns('/library')} className="footer-button">
          <FaBook />
          <span>Library</span>
        </button>
        <button
          onClick={toggleMobileAddDropdown}
          className="footer-button"
          data-action="add"
        >
          <FaPlus />
          <span>Add</span>
        </button>
        <button
          onClick={() => {
            closeAllDropdowns();
            navigate('/search');
          }}
          className="footer-button"
          data-action="search"
        >
          <FaSearch />
          <span>Search</span>
        </button>
        <button onClick={() => navigateAndCloseDropdowns(`/profile/${userId}`)} className="footer-button">
          <FaUser />
          <span>Profile</span>
        </button>
      </div>
    </>
  );
}

export default MobileHeader;
